import { render, staticRenderFns } from "./SitesTable.vue?vue&type=template&id=ab512b9c&scoped=true"
import script from "./SitesTable.vue?vue&type=script&lang=js"
export * from "./SitesTable.vue?vue&type=script&lang=js"
import style0 from "./SitesTable.vue?vue&type=style&index=0&id=ab512b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab512b9c",
  null
  
)

export default component.exports